import { render } from "./CTAComponent.vue?vue&type=template&id=932c799c"
import script from "./CTAComponent.vue?vue&type=script&lang=js"
export * from "./CTAComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__